import { SystemStyleObject } from '@chakra-ui/react';

export const customersDirectoryStyles: Record<string, SystemStyleObject> = {
  createButton: {
    h: '38px',
    px: 4,
  },
  content: {
    flexDirection: 'column',
    gap: 5,
  },
  actions: {
    flexShrink: 0,
  },
  search: {
    flex: '1 1 280px',
    maxW: { base: 'full', lg: '340px' },
  },
  table: {
    bg: 'entityDirectory.surface',
    border: '1px solid',
    borderColor: 'entityDirectory.border',
    borderRadius: 0,
    w: '100%',
  },
  results: {
    color: 'entityDirectory.mutedText',
    fontSize: '11px',
  },
  emphasis: {
    fontWeight: 'semibold',
  },
  statusCell: {
    alignItems: 'center',
    justifyContent: 'end',
  },
  name: {
    display: 'flex',
    alignItems: 'center',
    gap: 3,
    minW: 0,
  },
  logo: {
    boxSize: 8,
    objectFit: 'contain',
    flexShrink: 0,
  },
  nameText: {
    minW: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
};
